module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jdj5E"))).then(() => parcelRequire('iDabs'));